export default {
    getUser: (state) => {
        return state.user;
    },
    getUserCanWrite: (state) => (link) => {
        let result = false;

        if (state.user && state.user.roles) {
            state.user.roles.forEach(function(role, index, array) {
                if (role && role.permission_role_list) {
                    role.permission_role_list.forEach(function (permission, indexPermission, arrayPermission) {
                        if (permission.link == link) {
                            for (let permissionData in permission.permissions_data) {
                                if (permissionData == 'write') {
                                    if (permission.permissions_data[permissionData] == true) {
                                        result = true;

                                        break;
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }

        return result;
    },
    getUserCanUpdate: (state) => (link) => {
        let result = false;

        if (state.user && state.user.roles) {
            state.user.roles.forEach(function(role, index, array) {
                if (role && role.permission_role_list) {
                    role.permission_role_list.forEach(function (permission, indexPermission, arrayPermission) {
                        if (permission.link == link) {
                            for (let permissionData in permission.permissions_data) {
                                if (permissionData == 'update') {
                                    if (permission.permissions_data[permissionData] == true) {
                                        result = true;

                                        break;
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }

        return result;
    },
    getUserCanRead: (state) => (link) => {
        let result = false;

        link = link.startsWith('/') ? link.slice(1) : link;

        if (state.user && state.user.roles) {
            state.user.roles.forEach(function(role, index, array) {
                if (role && role.permission_role_list) {
                    role.permission_role_list.forEach(function (permission, indexPermission, arrayPermission) {
                        if (permission.link == link) {
                            for (let permissionData in permission.permissions_data) {
                                if (permissionData == 'read') {
                                    if (permission.permissions_data[permissionData] == true) {
                                        result = true;

                                        break;
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }

        return result;
    },
    getUserCanDelete: (state) => (link) => {
        let result = false;

        if (state.user && state.user.roles) {
            state.user.roles.forEach(function(role, index, array) {
                if (role && role.permission_role_list) {
                    role.permission_role_list.forEach(function (permission, indexPermission, arrayPermission) {
                        if (permission.link == link) {
                            for (let permissionData in permission.permissions_data) {
                                if (permissionData == 'delete') {
                                    if (permission.permissions_data[permissionData] == true) {
                                        result = true;

                                        break;
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }

        return result;
    },
}
